/* eslint-disable @nx/enforce-module-boundaries */
import { Box } from '@mybridge/ui/layout';
import { useSelector } from 'react-redux';
import styles from './footer.module.scss';
import dynamic from 'next/dynamic';
import { Portal, Spinner } from '@mybridge/ui';
import { useChatSocket } from 'packages/mybridgev4/hooks/useChatSocket';
import { useDisclosure } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import MeetingFloatingButton from 'v4/components/meeting/MeetingFloatingButton';

const BranchInit = dynamic(() => import('v4/components/branch-sdk/branch-init'), {
  ssr: false,
});
const ChatInit = dynamic(() => import('v4/components/chat/chat-init'), {
  ssr: false,
  loading: () => (
    <Box 
      position="fixed" 
      right="20px" 
      bottom="75px" 
      width="40px" 
      height="40px" 
      zIndex="100"
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="50%"
      bg="brandGray.500"
      boxShadow="0px 2px 6px 0px #00000033"
    >
        <Spinner size="sm" />
    </Box>
  )
});
const MeetingInit = dynamic(() => import('v4/components/meeting/meetingInit'), {
  ssr: false,
});

// const UseChatShocket = dynamic(() => import('v4/hooks/useChatSocket'), {
//   ssr: false,
// })

export const Footer = () => {
  const { loggedIn } = useSelector((state) => state.user);
  const { socketRef, isConnected, ...chatSocketProps } = useChatSocket();
  const meetingDisclosure = useDisclosure();
  const [isMeetingLoaded, setIsMeetingLoaded] = useState(false);
  
  // Preload MeetingInit when logged in or when hovering the button
  useEffect(() => {
    if (loggedIn) {
      // Intentional preloading of the dynamic chunk
      import('v4/components/meeting/meetingInit').then(() => {
        setIsMeetingLoaded(true);
      });
    }
  }, [loggedIn]);

  return (
    <Box className={styles.siteFooterContainer}>
      {loggedIn && ChatInit ? (
        // <Portal>
          <ChatInit chatSocketProps={chatSocketProps}/>
        // </Portal>
      ) : (
        ''
      )}

      {loggedIn && (
        <MeetingFloatingButton 
          onClick={meetingDisclosure.onToggle} 
          isLoading={meetingDisclosure.isOpen && !isMeetingLoaded}
        />
      )}

      {loggedIn && MeetingInit ? (
        <Portal>
          <MeetingInit externalDisclosure={meetingDisclosure} />
        </Portal>
      ) : (
        ''
      )}
      
      <BranchInit />
    </Box>
  );
};

export default Footer;
